/* eslint-disable react-hooks/rules-of-hooks */

import BodyText from 'components/Press/Bodytext';
import ButtonDownload from 'components/Press/ButtonDownload';
import DownloadArea from 'components/Press/DownloadArea';
import PressHeader from 'components/Press/Header';
import { Locale, Markets } from 'generated/graphql';
import { getPressRelease } from 'lib/graphql/getPressRelease';
import { getLocale } from 'modules/localesMapper';
import { GetServerSideProps } from 'next';
import { getCopy } from 'lib/utils/getCopy';
import { ContainerSubline } from '../../components/Press/ListingPage/style';
import { Text } from '../../components/Typography';
import { Spacer } from '../../components/Spacer';
import { PageMetaData } from '../../components/metaData';
import { doNotIndexPageOnAnyMarket } from '../../lib/utils/helpers';
import { CorpContactCardContainer } from '../../components/CorpContactCardContainer';
import Custom404 from '../404';
import { INotificationBannerProps } from 'components/NotificationBanner/types';
import Head from 'next/head';

function PressPage({
  serverData,
  locale,
  serverError,
  dictionary,
}: {
  serverData: any;
  env: string;
  locale: Locale;
  market: Markets;
  recallData: INotificationBannerProps;
  rewrites: Record<string, any>;
  serverError: boolean;
  apiUrl: string;
  dictionary: any;
}) {
  const pressRelease = serverData.pressReleases[0];

  if (serverError || !pressRelease) {
    return <Custom404 dictionary={dictionary} />;
  }

  const marketColor = pressRelease?.market?.search(/global/i) === -1 ? 'peach' : 'blue';
  const publishedAt = new Date(pressRelease?.date);
  const pressMeta = serverData?.pressReleases[0]?.metaData;
  const noIndex = doNotIndexPageOnAnyMarket(pressRelease);
  return (
    <>
      {!noIndex && (
        <Head>
          <meta name="robots" content="noindex,nofollow" />
        </Head>
      )}
      {noIndex && pressMeta && <PageMetaData metadata={pressMeta} locale={locale} />}
      <PressHeader type={marketColor} data={pressRelease} dictionary={dictionary} />
      <ContainerSubline>
        <Text type={'lead'} tag="p">
          {`${publishedAt.getDate()}.${publishedAt.getMonth() + 1}.${publishedAt.getFullYear()}`} •{' '}
          {getCopy(`press_tag_${pressRelease?.topicEnum}`, dictionary)}
        </Text>
      </ContainerSubline>
      <DownloadArea copy={dictionary} pressRelease={pressRelease} />
      <BodyText pressRelease={pressRelease} />
      {pressRelease?.corpContactCardContainer && (
        <>
          <Spacer size={40} />
          <CorpContactCardContainer data={pressRelease?.corpContactCardContainer} />
          <Spacer size={40} />
        </>
      )}
      <Spacer size={40} />
      <ButtonDownload link={'/media-library'} text={getCopy('media_download', dictionary)} />
      <ButtonDownload link={'/press'} text={getCopy('see_all_press_releases', dictionary)} />

      <Spacer size={100} />
    </>
  );
}

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const { locale = 'global', locales, resolvedUrl, params } = ctx;

  const error = false;
  const market = locale; // locale from path is representing market
  const currLocale = getLocale(market);
  const pageData = await getPressRelease(currLocale, params?.slug?.toString() || '');
  const data = pageData?.data;
  return {
    props: {
      locale: currLocale,
      env: process.env.RECIPE_ENV?.toLowerCase() || 'dev',
      serverData: data || {},
      locales,
      market,
      serverError: error,
    },
  };
};
export default PressPage;
